import { useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDInput from "../../../components/MDInput";

// NewProduct page components
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

import { useSelector, useDispatch } from "react-redux";

import { getUsers } from "api/users";

import { setAllUsers } from "redux/reducers/usersReducer";

export default function ResponsibleOrder({
  responsibleBusiness,
  setResponsibleBusiness,
  foreman,
  setForeman,
  salesman,
  setSalesman,
  managementAssistant,
  setManagementAssistant,
  projectManager,
  setProjectManager,
  buildingOwner,
  setBuildingOwner,
}) {
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.users.allUsers);

  async function fetchUsers() {
    const response = await getUsers();
    const formatedUsers = await response.data.map((user) => ({
      label: user.name,
      id: user.user_id,
    }));
    dispatch(setAllUsers(formatedUsers));
  }

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MDBox>
        <Grid container spacing={2}>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                options={allUsers}
                value={responsibleBusiness}
                onChange={(event, newResponsibleBusiness) => {
                  setResponsibleBusiness(newResponsibleBusiness);
                }}
                renderInput={(params) => (
                  <MDInput {...params} label="Commercial projet" variant="standard" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                options={allUsers}
                value={salesman}
                onChange={(event, newSalesman) => {
                  setSalesman(newSalesman);
                }}
                renderInput={(params) => (
                  <MDInput {...params} label="Commercial service" variant="standard" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                options={allUsers}
                value={foreman}
                onChange={(event, newForeman) => {
                  setForeman(newForeman);
                }}
                renderInput={(params) => (
                  <MDInput {...params} label="Contremaître" variant="standard" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                options={allUsers}
                value={managementAssistant}
                onChange={(event, newManagementAssistant) => {
                  setManagementAssistant(newManagementAssistant);
                }}
                renderInput={(params) => (
                  <MDInput {...params} label="Assistante de gestion" variant="standard" />
                )}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormField
                inputProps={{ maxLength: 255 }}
                value={projectManager}
                onChange={(event) => setProjectManager(event.target.value)}
                variant="standard"
                type="text"
                label="Maitre d'oeuvre / architecte"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField
                inputProps={{ maxLength: 255 }}
                value={buildingOwner}
                onChange={(event) => setBuildingOwner(event.target.value)}
                variant="standard"
                type="text"
                label="Maitre d'ouvrage"
              />
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
    </>
  );
}
